import { render, staticRenderFns } from "./desconocidos.vue?vue&type=template&id=5b5565ac&scoped=true&"
import script from "./desconocidos.vue?vue&type=script&lang=js&"
export * from "./desconocidos.vue?vue&type=script&lang=js&"
import style0 from "./desconocidos.vue?vue&type=style&index=0&id=5b5565ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5565ac",
  null
  
)

export default component.exports